<template>
  <div>
    <div v-for="r, index in $store.state.rh.mentorias" :key="index">
        <!-- NÍVEL MENTORES -->
        <ExpansivePanel>
            <template #titulo>{{r.first_name}} {{r.last_name}}</template>
            <template #descricao>Avaliador</template>
            <template #conteudo>
                <!-- AVALIACOES -->
                <div v-for="aval, avali in Object.keys(r.avaliacoes)" :key="avali">
                    <ExpansivePanel>
                        <template #titulo>{{`${aval.substring(8,10)}/${aval.substring(5,7)}/${aval.substring(0,4)}`}}</template>
                        <template #descricao>Data aplicação</template>
                        <template #conteudo>
                            <!-- NIVEL COLABORADORES -->
                            <div v-for="colab, colabi in r.avaliacoes[aval]" :key="colabi">
                                <ExpansivePanel>
                                    <template #titulo>{{colab.nome}} - {{colab.secao__setor}}</template>
                                    <template #descricao>Avaliado</template>
                                    <template #conteudo>
                                        <!-- NIVEL QUESTIONARIOS DO COLABORADOR -->
                                        <div v-for="aval_colab, aci in colab.questionarios||[]" :key="aci">
                                            <modal-gdb :toolbar-title="aval_colab.periodoquest__questionario__titulo" fullscreen dialogWidth="100%">
                                                <template v-slot:activate-slot>
                                                    <v-btn>
                                                        <span class="pl-2">{{aval_colab.periodoquest__periodo__descricao}} - 
                                                        </span>
                                                        <span v-html="aval_colab.periodoquest__questionario__titulo"></span>
                                                    </v-btn>
                                                </template>
                                                <template v-slot:body>
                                                    <pre v-show="false">{{aval_colab}}</pre>
                                                    <div>
                                                        <PreviewMentorias :selectedQuest="aval_colab" :classificar_avaliacao="classificar_avaliacao"/>
                                                    </div>                                                    
                                                </template>
                                            </modal-gdb>
                                        </div>
                                    </template>
                                </ExpansivePanel>
                            </div>
                        </template>
                    </ExpansivePanel>
                </div>
            </template>
        </ExpansivePanel>
    </div>
  </div>
</template>

<script>

import ExpansivePanel from '@/components/layouts/partials/ExpansivePanel.vue'
import PreviewMentorias from './PreviewMentorias.vue';
export default {
    name: 'MentoriasComponent',
    components: {
        ExpansivePanel,
        PreviewMentorias,
    },
    mounted(){
        this.$store.dispatch('GetRHMentorias')
    },
    data() {
        return {
            SINGLE: 'single',
            TEXT: 'text',
        };
    },
    methods: {
        classificar_avaliacao(pontos){
            /*
                - Até 20 pontos = limitado
                - De 20 a 28 pontos = básico
                - De 28 a 32 pontos = avançado
                - Acima de 32 = proficiente
            */
            if(pontos <= 20){
                return `${'Limitado'}`; //return `${'Limitado'} (${pontos})`;
            }else if (pontos <= 28){
                return `${'Básico'}`;
            }else if (pontos <= 32){
                return `${'Avançado'}`;
            }else{
                return `${'Proficiente'}`;
            }
        },
    }
};
</script>
